import _merge from 'lodash/merge';

export default class FolderService {
    /** @ngInject */
    constructor(FoldersApi, $q) {
        this.Api = FoldersApi;
        this.$q = $q;

        this.loadingPromise = null;
        this.folderTree = [];
        this.folderMap = {};
    }

    storeFolder(folder) {
        folder.children = [];
        this.folderMap[folder.id] = folder;
    }

    getFolder(id) {
        return this.folderMap[id];
    }

    loadPage(pageToken = '') {
        const options = {
            page_size: 100
        };

        if (pageToken) {
            options.page_token = pageToken;
        }

        this.Api
            .fetch(options)
            .then(this.processPage.bind(this), () => {
                this.loadingPromise.reject();
            });
    }

    processPage(data) {
        const folders = data.folders || [];
        folders.forEach((folder) => {
            this.storeFolder(folder);
        });

        if (data.next_page_token) {
            this.loadPage(data.next_page_token);
        } else {
            this.buildTree();
            this.loadingPromise.resolve();
        }
    }

    buildTree() {
        Object.keys(this.folderMap).forEach((folderId) => {
            const folder = this.getFolder(folderId);
            this.growTree(folder);
        });
    }

    growTree(folder) {
        if (!folder.parent_id) {
            this.folderTree.push(folder);
        } else {
            const parent = this.getFolder(folder.parent_id);
            if (parent) {
                parent.children.push(folder);
            }
        }
    }

    getChildrenIds(folder) {
        const result = [];
        if (folder.children.length) {
            folder.children.forEach((child) => {
                result.concat(child.id, ...this.getChildrenIds(child));
            });
        }
        return result;
    }

    cutTree(folder) {
        const childrenIds = this.getChildrenIds(folder);
        childrenIds.forEach((childId) => {
            delete this.folderMap[childId];
        });
        let parentChildren;
        if (folder.parent_id) {
            const parent = this.getFolder(folder.parent_id);
            if (parent) {
                parentChildren = parent.children;
            }
        } else {
            parentChildren = this.folderTree;
        }
        if (parentChildren) {
            const folderIndex = parentChildren.indexOf(folder);
            if (folderIndex >= 0) {
                parentChildren.splice(folderIndex, 1);
            }
        }
    }

    switchBranch(folder, parentId, index) {
        let oldChildren = this.folderTree;
        if (folder.parent_id) {
            const oldParentRef = this.getFolder(folder.parent_id);
            oldChildren = oldParentRef.children;
        }
        const oldIndex = oldChildren.indexOf(folder);
        if (oldIndex >= 0) {
            oldChildren.splice(oldIndex, 1);
        }

        let newChildren = this.folderTree;
        if (parentId) {
            const newParentRef = this.getFolder(parentId);
            newChildren = newParentRef.children;
        }
        if (index <= newChildren.length) {
            newChildren.splice(index, 0, folder);
        }

        folder.parent_id = parentId;
    }

    loadFolders() {
        if (this.loadingPromise) {
            return this.loadingPromise.promise;
        }

        this.loadingPromise = this.$q.defer();

        this.loadPage();

        return this.loadingPromise.promise;
    }

    getTree() {
        return this.folderTree;
    }

    buildFolderPath(folderId) {
        const path = [];
        let folder = this.getFolder(folderId);
        if (folder) {
            path.unshift(folder);
            while (folder.parent_id && !path.find(item => item.id === folder.parent_id)) { // eslint-disable-line no-loop-func,max-len
                const parent = this.getFolder(folder.parent_id);
                path.unshift(parent);
                folder = parent;
            }
        }
        return path;
    }

    addFolder(data) {
        return this.Api.create(data).then((folder) => {
            this.storeFolder(folder);
            this.growTree(folder);
            return folder;
        });
    }

    saveFolder(folder) {
        delete folder.children;
        return this.Api.update(folder.id, folder).then(() => {
            const folderRef = this.getFolder(folder.id);
            _merge(folderRef, folder);
        });
    }

    deleteFolder(folder) {
        return this.Api.remove(folder.id).then(() => {
            const folderRef = this.getFolder(folder.id);
            this.cutTree(folderRef);
        });
    }

    moveFolder(folder, parent, index) {
        const parentId = parent ? parent.id : null;
        const params = {};
        if (parentId) {
            params.parent_id = parentId;
        }
        return this.Api.move(folder.id, params).then(() => {
            const folderRef = this.getFolder(folder.id);
            this.switchBranch(folderRef, parentId, index);
        });
    }
}



// WEBPACK FOOTER //
// ./app/services/folders/folders.service.js